export enum EvenementTNR {
  PREAUT_NON_COMPLETEE = 'pre_autorisation_non_completee',
  PREAUT_ACCEPTEE = 'pre_autorisation_completee_acceptee',
  PREAUT_REFUSEE = 'pre_autorisation_completee_refusee',
  TNR_COOKIE = 'momentVerite',
  DOMAIN_DESJARDINS_COOKIE = '.desjardins.com'
}
